// Weather Roulette — a once-per-day free random-weather challenge.
// Winning pays 3× chips (via awardChipsForRun rouletteMult).
// Consumes the daily spin token in localStorage.
const KEY = "ppe_roulette_last_spin_v1";
const PENDING_KEY = "ppe_roulette_pending_v1";

function todayIso() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

export function isRouletteAvailable() {
  return localStorage.getItem(KEY) !== todayIso();
}

/** Pick a random harsh weather + save a "pending run" ticket. Returns the weather. */
export function spinRoulette() {
  const options = ["rain", "fog", "wind"];
  const type = options[Math.floor(Math.random() * options.length)];
  const intensity = 0.7 + Math.random() * 0.25; // 0.7 - 0.95
  localStorage.setItem(KEY, todayIso());
  const ticket = { type, intensity, level: "outdoor", spun_at: Date.now() };
  localStorage.setItem(PENDING_KEY, JSON.stringify(ticket));
  return ticket;
}

/** Read the pending roulette ticket, if any. Non-destructive. */
export function pendingRoulette() {
  try {
    const t = JSON.parse(localStorage.getItem(PENDING_KEY) || "null");
    if (!t) return null;
    // Auto-expire after 4h
    if (Date.now() - (t.spun_at || 0) > 4 * 3600 * 1000) {
      localStorage.removeItem(PENDING_KEY);
      return null;
    }
    return t;
  } catch {
    return null;
  }
}

export function consumeRoulette() {
  localStorage.removeItem(PENDING_KEY);
}
